<template>
  <div class="main" @touchmove.prevent>
    <div class="luckypage-bar">
      <span class="close-btn" @click="goback">关闭</span>
      <span class="bar-title">返利红包</span>
    </div>
    <div class="luckypage-content">
      <div class="radius-border"></div>
      <img v-lazy="userImgUrl" alt=""/>
      <p class="name-text">订单的返利红包</p>
      <p class="gx">恭喜发财,&nbsp;&nbsp;大吉大利</p>
      <p class="price"><b>{{buyPrice | formatPrice}}</b> 元</p>
      <p class="tip" @click="entoWaitBalance">已存入待返金额，确认收货后即可提现 </p>
    </div>
    <div class="lucky-foot" @click="goback">返回</div>
  </div>
</template>

<script>
import { RedPacketInfo } from '@/api/order'
import { getStore, removeStore } from '@/utils/session'

export default {
  data () {
    return {
      buyPrice: 0,
      taskID: null,
      userImgUrl: ''
    }
  },
  created () {
    this.userImgUrl = getStore('WXUserImg')
  },
  mounted () {
    this.buyPrice = this.$route.query.price ? this.$route.query.price : null
    this.taskID = this.$route.query.taskID ? this.$route.query.taskID : null
    if (this.taskID) this.fetchData()
  },
  beforeDestroy () {
    removeStore('WXUserImg')
  },
  methods: {
    fetchData () {
      RedPacketInfo({ taskId: this.taskID }).then(res => {
        this.userImgUrl = res.Data.HeadPortraitUrl
        this.buyPrice = res.Data.BuyRebatePrice
      })
    },
    goback () {
      this.$router.go(-1)
    },
    // 进入待返金额
    entoWaitBalance () {
      this.$router.push({
        name: 'balance',
        query: {
          type: 1
        }
      })
    }
  },
  filters: {
    formatPrice (val) {
      if (val) {
        return Number(val).toFixed(2)
      } else {
        return '0.00'
      }
    }
  }
}
</script>

<style scoped>
  .main{
    height: 100vh;
    width:100%;
    background: #fff;
    overflow:hidden;
  }
  .luckypage-bar{
    position: relative;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 18px;
    color: #f2d19a;
    background: #CE4D42;
    z-index: 10;
    transform: translate3d(0,0,0);
  }
  .luckypage-bar .close-btn{
    position: absolute;
    left: 3%;
    top: 0;
    font-size: 14px;
    color: #DDBE89;
  }
  .luckypage-content{
    width: 100%;
    max-width: 100%;
    background: #F3F1F4;
    overflow: hidden;
  }
  .radius-border{
    position: absolute;
    height: 45%;
    top: -27%;
    left: -15%;
    width: 130%;
    background: #CE4D42;
    border-radius: 50%;
  }
  .luckypage-content img{
    position: absolute;
    top: 12%;
    left: 50%;
    height: 65px;
    width: 65px;
    border: 1px solid #f2d19a;
    border-radius: 5px;
    transform: translateX(-50%);
    z-index: 10;
  }
  .luckypage-content p{
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
  }
  .luckypage-content .name-text{
    padding-top: 30%;
    font-weight: 600;
  }
  .luckypage-content .price > b{
    font-size: 40px;
  }
  .luckypage-content .tip{
    color: #3d76e4;
    padding-bottom: 20px;
  }
  .lucky-foot{
    height: 70px;
    line-height: 70px;
    font-size: 18px;
    text-align: center;
    border-bottom: 1px solid #eee;
    letter-spacing: 5px;
  }
  @media screen and (max-height: 480px) {
    .radius-border{
      top: -24%;
    }
    .luckypage-content .name-text{
      padding-top: 25%;
    }
  }
  /* ----------------- animete ------------------ */
  .close-btn,
  .bar-title,
  .luckypage-content .tip,
  .lucky-foot{
    animation: textOpacityAnim .3s .5s ease-in;
    animation-fill-mode: backwards;
  }
  .luckypage-content .name-text,
  .luckypage-content .gx,
  .luckypage-content .price{
    animation: textScaleAnim .3s .3s ease-out;
    animation-fill-mode: backwards;
  }
  .radius-border{
    animation: radiusAnim .3s ease-out;
    animation-fill-mode: backwards;
  }
  .luckypage-content img{
    animation: iconAnim .2s ease-out;
    animation-fill-mode: backwards;
  }
  .luckypage-content .tip{
    animation: btmAnim .4s ease-in;
    animation-fill-mode: backwards;
  }
  @keyframes iconAnim{
    0%{
      top: 20%;
      border: 5px solid #f2d19a;
    }
    100%{
      top: 12%;
      border: 1px solid #f2d19a;
    }
  }
  @keyframes radiusAnim{
    0%{
      top: -15%;
    }
    100%{
      top: -27%;
    }
  }
  @keyframes textScaleAnim{
    0%{
      transform: scale(1.5);
    }
    100%{
      transform: scale(1);
    }
  }
  @keyframes textOpacityAnim{
    0%{
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
  @keyframes btmAnim{
    0%{
      padding-bottom: 90%
    }
    100%{
      padding-bottom: 20px;
    }
  }
</style>
